import { YesNoEmpty } from '@interfaces/models';

export interface MultiAccountState {
  isCrewOnMultiTransactionFlow: YesNoEmpty;
}
